import React, { useState, useEffect } from 'react';

import { Grid, Row, Col, Typography } from '@sm/wds-react';
import { TabletScreen } from '@sm/webassets';
import { T } from '@sm/intl';

import getLocalizedLogos from './getLocalizedLogos';
import './used-in-orgs.scss';

export const COPY = {
  title: {
    id: 'mrx.UsedInOrgs.title',
    defaultMessage: 'Leading brands use SurveyMonkey for market research',
    description:
      '[Type: Header][Vis: med] - Title of the section of the market research hub where we show companies that use our products'
  }
};

export const TEST_ID = 'UsedInOrgs';

const UsedInOrgs = () => {
  const [logos, setLogos] = useState(null);
  useEffect(() => {
    getLocalizedLogos().then(data => setLogos(data));
  }, []);
  return (
    <Grid
      noBleeds
      noGutters
      fluid
      className="sm-used-in-orgs"
      data-testid={TEST_ID}
    >
      <Row className="sm-used-in-orgs__title-row">
        <TabletScreen>
          <Col md={0} lg={1} xl={3} />
        </TabletScreen>
        <Col>
          <Typography
            align="center"
            component="h2"
            className="sm-used-in-orgs__title"
          >
            <T desc={COPY.title} />
          </Typography>
        </Col>
        <TabletScreen>
          <Col md={0} lg={1} xl={3} />
        </TabletScreen>
      </Row>
      <If condition={logos}>
        <Row>
          {logos.map(logo => (
            <Col key={logo.id} className="sm-used-in-orgs__logo-wrapper">
              <img
                className="sm-used-in-orgs__logo"
                src={logo.image}
                alt={logo.name}
              />
            </Col>
          ))}
        </Row>
      </If>
    </Grid>
  );
};

export default UsedInOrgs;
